import _ from "lodash";
import React from "react";

import { testLocator } from "@/lib/helpers/test-locator";
import { TextArea2 } from "@/ui2/atoms/TextArea";

import { SectionCardWrapper } from "./SectionCardWrapper";

export function GenericSectionNotes(props) {
  const {
    editable,
    editHandler,
    note,
    profileView,
    renderExtra,
    sectionKey,
    sectionLabel,
    textareaProps,
  } = props;

  let sectionNote = note.content[sectionKey];

  const [editCopy, setEditCopy] = React.useState(_.cloneDeep(sectionNote));

  return (
    <SectionCardWrapper
      cardProps={{ className: "tw:p-5", style: { minHeight: 300 } }}
      plainProps={{ style: { minHeight: 300 } }}
      profileView={profileView}
    >
      <strong className="clr-sec tw:font-bold">
        {sectionLabel} {renderExtra && renderExtra()}
      </strong>

      {!editable ? (
        <p className="tw:text-sm tw:text-text-primary">{sectionNote}</p>
      ) : (
        <TextArea2
          className="tw:box-border tw:w-full"
          onChange={(e) => {
            setEditCopy(e.target.value);

            if (editHandler) {
              editHandler(sectionKey, e.target.value);
            }
          }}
          rows={12}
          value={editCopy}
          {...textareaProps}
          {...testLocator(`${sectionKey}TextArea`)}
        />
      )}
    </SectionCardWrapper>
  );
}
